//en.js
import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
  message: {
    'city_and_vendor':'City and Vendor',
    'vendor':'Vendor',


    'DDV': 'DDV',
    'Wuhan':'Wuhan',
    '武汉':'Wuhan',
    'Nanjing':'Nanjing',
    '南京':'Nanjing',
    'Shenzhen':'Shenzhen',
    '深圳':'Shenzhen',
    'Chongqing':'Chongqing',
    '重庆':'Chongqing',
    'Chengdu':'Chengdu',
    '成都':'Chengdu',
    'Shanghai':'Shanghai',
    '上海':'Shanghai',
    'Hongkong':'Hongkong',
    '香港':'Hongkong',
    'Beijing':'Beijing',
    '北京':'Beijing',
    'Central':'Central',
    '巴士总部':'Central ',
    'xinyun':'新云',
    'tiandi':'天迪',
    'baoyuan':'宝苑',
    'suote':'索特',

    'info':'info',
    'confirm_operation':'Do you confirm operation？',
    'authority':'Authority',
    'allowed_discount':'Allowed discount',
    'report_to':'Report to',
    'BU':'BU',
    'role':'Role',
    'name':'Name',
    'Remove':'Remove',
    'Detail':'Detail',
    'edit_user':'Edit User',
    'unselected':'No-actived',
    'selected':'Activated',
    'UserMangement':'User Mangement',
    'Mobile_Notif':'Mobile version is now available  ! ',
    'Index_Performance':'Index Performance: ',
    'Index_Distribution':'Index Distribution:',
    'Index_Distribution_Chart':'Index Distribution',
    'Grade_Distribution':'Grade Distribution',
    'Grade_Distribution_Chart':'Grade Distribution',
    'locate':'locate',
    'Give_it_a_price':'Give it a price',
    'summary':'summary',
    'Top_125+':'Top(125+)',
    'Avg+_125_100':'Avg+(125-100)',
    'Avg-_100_75':'Avg-(100-75)',
    'Low_75-':'Low(75-)',
    'Please_Select':'Please select',
    'Select':'Select',
    'Cost':'Cost',
    'Nbr_Of_Bus_Lines':'Nbr of Bus lines',
    'Buses_bodies':'Buses bodies',
    'Package_Validity':'Package Validity',
    'all_packages':'all packages',
    'Delete':'Delete',
    'Publish':'Publish',
    'View':'View',
    'published_packages_only':'published packages only',
    'unpublished_packages_only':'unpublished packages only',
    'expired_packages':'expired packages',
    'Save_Package':'Save Package',
    'Bulk':'Bulk',
    'From':'From',
    'to':'to',
    'description2':'Description',
    'Please_select_package_valid_period':'Please select package valid period',
    'Save_Changes':'Save Changes',
    'adjust':'Give it a name',
    'Package_Index_Distribution':'Package Index Distribution',
    'Package_Grade_Distribution':'Package Grade Distribution',
    'Package_History':'Package History',
    'Package_Information': 'Package Information',
    'Package_Name2':'Package Name',
    'Calculate':'Calculate',
    'Valited_Until':'Valited Until',
    'Description':'Description',
    'Product_Cost_Discount':'Product Cost Discount',
    'Impression':'Impression',
    'Ratecard_CPM':'Ratecard CPM',
    'Package_CPM':'Package CPM',
    'Package_CPM_cluster':'Package CPM\n(cluster)',
    'Round_Up_Cost':'Round Up Cost',
    'Total_Package_Cost':'Total Package Cost',
    'Calculation':'Calculation',
    'Final_Package_Cost':'Final Package Cost',
    'Bus_body(qty)':'Bus body(qty)',
    'Grading':'Grading',
    'Bus':'Bus',
    'Viewed_Impression(Audience)_row': 'Viewed\nImpressions\n(Cluster)',
    'Bus_Line_Qty':'Bus Line Qty',
    'Bus_Body_Qty':'Bus Body Qty',
    'Viewed_Impression_row':'Viewed\nImpression',
    'Num_of_POI':'Num of POI',
    'Create_Package':'Create Package',
    'platform_title':'BUS AUDIENCE MEASUREMENT',
    'Draft': 'Draft',
    'Discussion': 'Discussion',
    'Sent': 'Sent',
    'Win': 'Win',
    'Fail': 'Fail',
    'Archive': 'Archive',
    'Notice': 'Notice',
    'Notice_dia':'Are you sure to change the quantity of bus for all the bus lines？',
    'Notice_Content':'Are you sure to continue ?',
    'Notice_Yes':'Next',
    'Notice_Cancel':'Cancel',
    'Select':'Select',
    'POIType':'POI by Types',
    'POILocation':'AOI by Location',
    'LegacyFixedSystem':'Fixed ranking system - can be combined with other selections to filter bus lines',
    'ByAudience':'By Audience',
    'ByPointsOfInterest':'By Points of Interest',
    'Select_Media_Format':'Media Format',
    'Select_Media_Format_1':'Select Media Format',
    'CampaignByPerformanceCriterias':'Select your performance criterias',
    'RegularRateCard':'Fast Track',
    'General': 'Overview',
    'Advanced': 'Advanced',
    'Performance_Criterias':'Criterias',
    'Next_Step':'Next Step',
    'Done':'Done',
    'Files':'Files',
    'Edit':'Edit',
    'Share':'Share',
    'Share_the_proposal':'Share the proposal',
    'Share_with':'Share with',
    'Please_select_the_users':'Please select the users',
    'Cancel':'Cancel',
    'Confirm':'OK',
    'Success':'Success',
    'Share_with_success':'Share with success',
    'Warning':'Warning',
    'This_proposal_has_been_already_shared_with_user':'This proposal has been already shared with $user',
    'Error':'Error',
    'Fail_to_share':'Fail to share',
    'Please_enter_the_client_name': 'Please enter the client name',
    'The_data_is_successfully_uploaded': ' The data is successfully uploaded!',
    'The_data_is_failed_to_upload': ' The data is failded to upload!',
    'Select_this_city': 'Select this city',
    'Select_cities': 'Select cities',
    'Upload_inventory': 'Upload inventory',
    'Choose_one_city': 'Choose one city',
    'Desperately_loading': 'Loading...',
    'textCPM': 'CPM = 1000 * Gross Rate / Viewed impressions',
    'textViewedImpressions': 'A unit of measure that includes the total number of people with an opportunity to see (aka traffic), notice, and dwell time, calibrated to the media’s spot length. It can also be explained as the total number of times people passing a digital out-of-home display or static one are likely to notice a message.This concept is sometimes referred to as “Visibility Adjusted Contact”, or “VAC”. ',
    'Error': 'Error',
    'Login': 'Login',
    'Hello': 'Hello',
    'Email': 'Email',
    'rank': 'rank',
    'Months':'Months',
    'Training': 'Training',
    'To_ensure_your_better_experience_please_use_chrome_browser': 'To ensure your better experience, please use chrome browser',
    'Recommended_Bus_Lines_Text1':'Index= The best performing Line according to criterias selected on previous Page.',
    'Recommended_Bus_Lines_Text2':'General mechanism : Average = 100',
    'Recommended_Bus_Lines_Text3':'Line X index = 123',
    'Recommended_Bus_Lines_Text4':'Line Y = 102',
    'Recommended_Bus_Lines_Text5':'Line Z = 78',
    'Recommended_Bus_Lines_Text6':'i.e.: 2 first lines are performing correctly compared to the average (100)',
    'Recommended_Bus_Lines_Text7':'i.e.: Last line has less relevance to my selection',
    'Recommended_Bus_Lines_Text8':'Note : Multiple criterias are affecting you choice : the characteristics of the audience, but also the combination with POIs.',
    'Recommended_Bus_Lines_Text9':'Example : A selection with :',
    'Recommended_Bus_Lines_Text10':'-Female  & 25-34',
    'Recommended_Bus_Lines_Text11':'Or',
    'Recommended_Bus_Lines_Text12':'-Female & 25-34 & Shopping malls',
    'Recommended_Bus_Lines_Text13':'Will provide a different index for the same Bus line. It is therefore dynamic and will change accordingng to your selection.',
    'Password': 'Password',
    'Bus_Audience': 'Bus Audience',
    'Measurement': 'Measurement',
    'Recommended_Bus_Lines': 'Recommended Bus Lines',
    'Population': 'Population',
    'Audience': 'Target Profile',
    'Nanjing': 'Nanjing',
    'Wuhan': 'Wuhan',
    'audience': 'Audience',
    'audience_info': 'Audience Information',
    'campaign_info': 'Campaign Information',
    'Please_select_a_city_to_explore_more': 'Please select a city to explore more',
    'Kms_covered': 'Kms covered',
    'Bus_Lines': 'Bus Lines',
    'Population_of_': 'Population of ',
    'Audience_of_': 'Audience of',
    'Please_Contact_IT': 'Please Contact IT',
    'Please_select_a_city_first': 'Please select a city first',
    'Welcome': 'Welcome',
    'Sign_Out': 'Sign Out',
    'History': 'History',
    'Statistics':'Statistics',
    'City': 'City',
    'Date': 'Date',
    'TRIP': 'TRIP',
    'Audience_information': 'Audience information',
    'Gender': 'Gender',
    'Age': 'Age',
    'Spend_Power': 'Spending Power',
    'Interests': 'Interests',
    'BUSINESS': 'BUSINESS',
    'Business_Center': 'Business Center',
    'Industrial_Park': 'Industrial Park',
    'Government': 'Government',
    'ENTERTAINEMENT': 'ENTERTAINMENT',
    'Sports': 'Sports',
    'Entertainment': 'Entertainment',
    'Culture': 'Culture',
    'LIVING': 'LIVING',
    'Shopping': 'Shopping',
    'Residental_Area': 'Residental Area',
    'Food_Drinks': 'Food & Drinks',
    'School_University': 'School & University',
    'Hospital': 'Hospital',
    'Tourist_Attractions': 'Tourist Attractions',
    'Transportation_Hub': 'Transportation Hub',
    'Art_Museum': 'Art & Museum',
    'Media_Format': 'Format',
    'Estimated_Cost': 'Estimated Cost',
    'Rank': 'Grade\n(Legacy)',
    'Legacy': 'Legacy',
    'POI': 'Target POI',
    'Nearby_Location': 'Nearby Location',
    'Info': 'Info',
    'The_data_is_based_on_your_ranking': 'The data is based on your ranking',
    'Selected_Recommended_Bus_Lines': 'Selected & Recommended Bus Lines',

    'Please_Contact_IT': 'Please Contact IT',
    'Please_select_a_city_first': 'Please select a city first.',

    'Please_select_the_audience_profile_for_the_measurement_solution': 'Please select the audience profile for the measurement solution',
    'Please_select_the_POI_information_for_the_measurement_solution': 'Please select the POI information for the measurement solution',
    'Please_select_the_bus_media_format_available_in_your_inventory': 'Please select the bus media format available in your inventory',
    'Please_select_the_bus_product_rank_in_your_inventory': 'Please select the bus product rank in your inventory',
    'Information': 'Information',
    'Graphic_Chart': 'Graphic Chart',
    'Commercial': 'Commercial',
    'Modify_Information': 'Modify Information',
    'Potential_Audience': 'Potential Audience',
    'Total_Media_Cost': 'Media Cost Total ¥',
    'CPM': 'CPM ¥',
    'CPM_1': 'CPM',
    'Adjusted_CPM': 'CPM (Selection Based)',
    'CPM_Selection_Based': 'CPM\n(Cluster) ¥',
    'CPM_Selection_Based_1': 'CPM (Cluster)',
    'CPM_Target_Audience_Based': 'CPM\n(Cluster) ¥',
    'CPM_Target_Audience_Based_1': 'CPM (Cluster)',
    'CPM_Total_And_Selection':'CPM (Total/Cluster)',
    'CPM_chart':'CPM ¥',

    'No_Authority':'No Authority',
    'Bus_Line': 'Line',
    'Related_Location_Number':'Location\npcs',
    'Media_Format': 'Media Format',
    'Media_Cost': 'Media Cost\n/Mth/Unit ¥',
    'Production_Cost': 'Production Cost\n(per bus quantity)',
    'Bus_Quantity': 'Bus\nQuantity',
    'Gross_Price': 'Gross Price',
    'Reach': 'Reach',
    'Frequency': 'Frequency',
    'Save_Data': 'Save Data',
    'Line': 'Line',
    'index': 'Index',
    'index2': 'Index',
    'operation': 'Operation',
    'Total_Media_Cost': 'Total\nMedia Cost ¥',
    'Total_Media_Cost_1': 'Total Media Cost',
    'Total_Media_Cost_2': 'Total Media Cost ¥',
    'Total_Media_Cost_RC': 'Total Media Cost (Rate Card) ¥',
    'Gross_CPM': 'CPM ¥',
    'Gross_CPM_1': 'Cost Per Mille',
    'Total_Production_Cost': 'Total Production Cost',
    'Total_Production_Cost_RC': 'Total Production Cost (Rate Card) ¥',
    'Total_Media_Budget': 'Total Media Budget',
    'Bus_Body': 'Bus Body',
    'Format': 'Format',
    'Number_of_Bus_Lines': 'Number of Bus Lines',
    'Number_of_Lines_And_Bus': 'Number of Lines / Bus',
    'Number_of_Bus_Body': 'Bus Quantity',
    'Duration(Months)': 'Duration (Months)',
    'Audience_Reach(%)': 'Audience Reach (%)',
    'Viewed_Impression': 'Viewed Impressions',
    'Distinct_Audience': 'Visibility Adjusted Unique Reach',
    'textCoverageAudience':'单月覆盖人口（预测值）', 
    'textOneMonthFreq':'单月受众看到广告的平均次数', 
    'textCovergaePercentage':'城市人口中看到广告至少一次的人群比例', 
    'One_Month_Freq': 'Visibility Adjusted Frequency',
    'Covergae_Percentage': 'Visibility Adjusted Reach',
    'Viewed_Impression_2': '\nViewed Impressions',
    'Viewed_Impression_chart': 'Viewed Impressions',
    'Viewed_Impression()': 'Viewed\nImpressions',
    'Viewed_Impression(Audience)': 'Viewed Impressions\n(Cluster)',
    'Viewed_Impression(Audience)_1': 'Viewed Impressions (Cluster)',
    'Viewed_Impression_Total_And_Selection': 'Viewed Imp (Total/Cluster)',
    'Audience_Reach': 'Audience Reach(%)',
    'Viewed_Impression_Selection_Based': 'Viewed Impressions\n(Selection Based)',
    'Back': 'Back',
    'Next': 'Next',
    'Commercial': 'Commercial',
    'Cancel': 'Cancel',
    'Cancelled':'Cancelled',
    'Media_Cost_Discount':'Media Cost Discount',
    'Data_is_saved':'Data is saved!',
    'OK': 'OK',
    'Do_you_want_to_save_data_you_made':'Do you want to save data you made?',
    'Global': 'Global',
    'Campaign_Starting_Date': 'Start Date',
    'Campaign_Starting_Date_1': 'Campaign Starting Date',
    'Duration': 'Duration',
    'Duration2': 'Duration\n(Month)',
    'Duration3': 'Duration(Month)',
    'Campaign_Starting_Date_And_Duration': 'Start Date / Duration',
    'Month': 'mo.',
    'Estimated_Potential_Audience': 'Estimated viewed impression (selection related)',
    'Viewed_impression_Upgraded_metric':'Viewed impression = Upgraded metric',
    'Viewed_impression_reflects_the_number_of_people':'Viewed impression reflects the number of people that have actually \'fixed\' the ad for at least 1 second (can be Compared to Click through in online) and this comes to replace OTS',
    'This_methodology_includes_complex_viewability_factors_already_used_internationally_by_the_OOH_industry': 'This methodology includes complex viewability factors already used internationally by the OOH industry (distance, size of ad, speed of vehicles…etc), which is a new notion to explain to market.',
    

    'Sunday': 'Sunday',
    'Monday': 'Monday',
    'Tuesday': 'Tuesday',
    'Wednesday': 'Wednesday',
    'Thursday': 'Thursday',
    'Friday': 'Friday',
    'Saturday': 'Saturday',
    'Jan': 'Jan',
    'Feb': 'Feb',
    'Mar': 'Mar',
    'Apr': 'Apr',
    'May': 'May',
    'Jun': 'Jun',
    'Jul': 'Jul',
    'Aug': 'Aug',
    'Sep': 'Sep',
    'Oct': 'Oct',
    'Nov': 'Nov',
    'Dec': 'Dec',
    'Refresh': 'Refresh',
    'Please_select_file_type': 'Please select file type.',
    'Import':'Import',
    'Export':'Export',
    'Export_PDF':'Export PDF',
    'Upload_logo':'Upload logo',
    'Client_name':'Client Name',
    'File_Type':'File Type',
    'Total_indicators':'Total Indicators',
    
    'Proposal_Status_Reminder': 'Proposal Status Reminder',
    'Proposal_Status_Reminder_number_old': 'Proposal Status Reminder - {{number}} records',
    'Proposal_Status_Reminder_number': 'You have {{number}} proposals without progress over time, please update the status!',
    'Got_it': 'Got it',
    'Created_at':'Created at',
    'Updated_at':'Updated at',
    'Package_name':'Package name',
    'Validation_Start':'Validation Start',
    'Validation_End':'Validation End',
    'Campaign_start':'Campaign start',
    'Campaign_end':'Campaign end',
    'Created_by':'Created by',
    'Actions':'Actions',
    'Team':'Team',
    'Status':'Status',
    'Operation':'Operation',
    'You_must_select_one_media_format':'You must select one media format',
    
    'Average':'Average: ',

    'Overall_distribution_gender':'Overall (Gender)',
    'Detailed_distribution_gender':'Detailed distribution (Gender)',
    'Overall_distribution_age':'Overall (Age)',
    'Detailed_distribution_age':'Detailed distribution (Age)',
    'Overall_distribution_spend_power':'Overall (Spending power)',
    'Detailed_distribution_spend_power':'Detailed distribution (Spending power)',
    'Overall_distribution_interest':'Overall (Interest)',
    'Detailed_distribution_interest':'Detailed distribution (Interest)',

    'gender_female' : 'Female',
    'gender_male' : 'Male',
    'age_18_24' : '18-24',
    'age_25_34' : '25-34',
    'age_35_44' : '35-44',
    'age_45_54' : '45-54',
    'age_55_64' : '55-64+',
    'spend_power_low' : 'Low',
    'spend_power_medium' : 'Medium',
    'spend_power_high' : 'High',
    'spend_power_low_income' : 'Low income',
    'spend_power_middle_income' : 'Middle income',
    'spend_power_middle_class' : 'Midlle class',
    'spend_power_upper_middle_class' : 'Upper midlle class',
    'spend_power_rich' : 'Rich',
    'spend_power_super_rich' : 'Super rich',
    'interest_banking_finance' : 'Banking & Finance News',
    'interest_beauty_healthcare' : 'Beauty & Healthcare',
    'interest_cars_it' : 'Cars & IT Products',
    'interest_lifestyle_catering' : 'Lifestyle & Catering',
    'interest_online_shopping_social_media' : 'Online Shopping & Social Media',
    'interest_online_training_education' : 'Online Training Education',
    'interest_video_entertainment' : 'Online Video Entertainment',
    'interest_travel_tourism' : 'Travelling & Tourism',

    'proposal_status' : 'Proposal Status     ',
    'process_status': 'Application Status',
    '7_days':'7 days',
    '30_days': '30 days',
    '90_days': '90 days',

    'Number_of_lines':'Number of lines',
    'Package_Name':'Package Name',
    'Please_select_package_valid_period':'Please select package valid period',
    'Validate_Until': 'Validate Until',
    'Bulk':'Bulk',
    'Number_of_POIs':'Number of POIs',
    'Total_bus_line_QTY':'Total bus line QTY',
    'Total_bus_body_QTY':'Total bus body QTY',

    
    'textProposalStatistics':'By preparation date',
    'Select_Date':'Select Date',
    'textProposalTop':'Only for sent status',
    'Top_5_Valued_Proposal_Summary':'Top 5 Valued Proposal Summary',
    'Average_Proposal_Value': 'Average Proposal Value',
    'Average_Viewed_Impressions':'Average Viewed Impressions',
    'Viewed_Impressions_Generated':'Viewed Impressions Generated',
    'Proposals':'Proposals',
    'Top_50_popular_bus_lines':'Top 50 popular bus lines',
    'Proposal_Value':'Proposal Value',
    'Viewed_Impressions':'Viewed Impressions',
    'Select_Range':'SelectRange',
    'To':'To',

    'Upload_Inventory_Progress': 'Upload in progress, please wait ...',
    'Upload_Inventory_Success': 'Upload succesfully, the inventory will be updated soon.',
    'Upload_Inventory_Error_Network': 'Fail to transfer the file to the server.',
    'Upload_Inventory_Error_Excel': 'Only Excel files supported, please check.',
    'Upload_Inventory_Error_Col_Missing': 'Column missing in Excel file, please check.',
    
    'Bus_Body_Warning_Text': 'Line {{line}} only has {{remaining}} remaining, but you pick {{selected}} bodies.',
    'Bus_Body_Remaining_Tooltip': '{{remaining}} remaining',
    'Bus_Body_No_Inventory_Tooltip': 'No inventory info of this line',
    'Upload_History': 'Upload History',
    'Please_select_a_proposal': 'Please select a proposal',
    'Proposal_selected': 'Proposal selected',
    'General' : 'General',
    
    'Search_client': 'Search client: ',
    'Search_creator': 'Search creator: ',
    'Please_enter_keyword': 'Please enter keyword',
    'Filter': 'Filter',
    'Reset': 'Reset',
    'Filter_Confirm': 'Confirm',

    'Distribution_of_road_types': 'Distribution of Road Types', 
    'Distribution_of_road_types_Chart': 'Distribution of Road Types', 
    'Proportion': 'Proportion',
    '1W-2L-R': '1-way 2-lane',
    '1W-3L-R': '1-way 3-lane',
    '2W-2L-R': '2-way 2-lane',
    '2W-4L-R': '2-way 4-lane',
    '2W-6L-R': '2-way 6-lane',
    '2W-8L-R': '2-way 8-lane',
    'Highway': 'Highway',
    
    'Hourly_Pattern_Audience_Distribution': 'Hourly pattern: Daytime Viewed Imp Distribution',
    'Hourly_Pattern_Audience_Distribution_Chart': 'Hourly pattern: Daytime Viewed Imp Distribution',
    'Workday': 'Workday',
    'Weekend': 'Weekend',

    'Bus_network_length': 'Network length',
    'Bus_stops': 'Bus stops',
    'Total_AOI': 'Total AOI',
    'Total_POI': 'Total POI',
    
    'Media_Cost': 'Media Cost',
    'Production_Cost_1': 'Production Cost',
    'Proposal_Cost': 'Total Cost',
    'Total_Cost': 'Total Cost',
    
    'Media_CPM': 'Media CPM',
    'Media_CPM_cluster': 'Media CPM\n(cluster)',
    'Proposal_CPM': 'Total CPM',
    'Proposal_CPM_cluster': 'Total CPM\n(cluster)',
    'Proposal_CPM_cluster_1': 'Total CPM (Cluster)',
    'Total_Proposal_CPM_1': 'Total Proposal CPM',
    'Total_Proposal_CPM_2': 'Proposal CPM\n(total)',
    
    'Media_CPM_Total_And_Selection':'Media CPM (Total/Cluster)',
    'Media_CPM_Total_And_Selection_1':'Media CPM\n(Total/Cluster)',
    'Proposal_CPM_Total_And_Selection':'Total CPM (Total/Cluster)',
    'Proposal_CPM_Total_And_Selection_1':'Total CPM\n(Total/Cluster)',
    'Proposal_CPM_Selection_And_Total':'CPM (Cluster/Total)',
    'Rate_Card_Media_CPM_Total_And_Selection':'Original Media CPM (Total/Cluster)',
    'Rate_Card_Media_CPM_Total_And_Selection_1':'Original Media CPM\n(Total/Cluster)',
    'Rate_Card_Proposal_CPM_Total_And_Selection':'Original Total CPM (Total/Cluster)',
    'Rate_Card_Proposal_CPM_Total_And_Selection_1':'Original Total CPM\n(Total/Cluster)',
    'Last_Year': 'Last Year',
    'This_Year': 'This Year',
    'This_Month': 'This Month',
    'quarter_1':'Q1',
    'quarter_2':'Q2',
    'quarter_3':'Q3',
    'quarter_4':'Q4',
    'Total_Pipeline': 'Total pipeline',
    'Wins':'Wins',
    'Trend':'Wins Trend',
    'Avg_Cycle':'AVG.Cycle',
    'Cycle':'Cycle Trend',
    'Achievement_vs_Target':'Achievement vs Target',
    'name':'Name',
    'Activity':'Activity',
    'Date':'Date',
    'Client':'Client',
    'Discount':'Discount',
    'Whole_Cycle':'Cycle',
    'Days':'days',
    'Input_Target':'Please input your target ',
    'YOY_Trend':'YOY Trend',
    'Statistic_proposal':'Proposal',
    'Avg_Discount':'Avg.Discount',
    'Page_View':'Page View',
    'Table_Num_Proposal':'Number of proposals',

    'Pricing':'Pricing',
    'Rate_Card_Price':'Rate Card Price',
    'Rate_Card_Proposal_Cost':'Total Price (original)',
    'Rate_Card_Proposal_CPM':'Total CPM (original)',
    'Rate_Card_Proposal_CPM_1':'CPM (original)',
    'Rate_Card_Media_Cost':'Media Price (original)',
    'Rate_Card_Media_Cost_1':'Media Price\n(original)',
    'Rate_Card_Media_CPM':'Media CPM (original)',
    'Rate_Card_Production_Cost':'Production Price (original)',
    'Rate_Card_Production_Cost_1':'Production Price\n(original)',
    'Reduced_Rate':'Reduced Rate',
    'Discounted_Price':'Discounted Price',
    'Media_Discount': 'Media Discount',
    'Proposal_Discount': 'Proposal Discount',
    'Discount_Type': 'Discount Type',
    'Quarterly_target_percentage_warning':'Warning: The sum of quarterly percentage is greater than 100',
    'Setting_sales_target': 'Set up sales target',
    'Back_to_new_version': 'Back to new version',
    'Back_to_old_version': 'Back to old version',
    'Setting':'Setting',
    'Annual_target':'Annuel Target',
    'Q1_target':'Q1 Target',
    'Q2_target':'Q2 Target',
    'Q3_target':'Q3 Target',
    'Q4_target':'Q4 Target',
    'Can_crosscity':'Cross-City',
    'Total_Audience': 'Total Audience',
    'Target_Audience': 'Target Audience',
    
    'Media_Cost_RC_Discounted': 'Media Cost\n(Original/Discounted)',
    'Exporting': 'Exporting...',
    'Quiz_pub': 'Scan or click the QR code, testing your knowledge of DOOH terms!',
    'Discount_Warning': 'The current discount requires the department director\'s approval',
    'Discount_Warning_External': 'Current discount is too low, please contact administrator',
    'No_salesdirector_Warning': 'Approval cannot be created because of no sales director now',
    'Discount_Notice': 'The current discount requires the department director\'s approval, this proposal will go to the approval process.',
    'Client_Name_Notice': 'Please enter client name',
    'Proposal': 'Proposal',
    'Appliance': 'Application',
    'Pending': 'Pending',
    'Approved_by_Director': 'Approved',
    'Changed_by_Director': 'Changed',
    'Refused_by_Director': 'Refused',
    'Accepted': 'Accepted',
    'Refused': 'Refused',
    'Review': 'Review',
    'Withdraw': 'Withdraw',
    'Comment': 'Comment',
    'Refuse': 'Refuse',
    'Accept': 'Accept',
    
    'Withdraw_Process_Notice': 'Are you sure you want to withdraw this application ?',
    'Confirm_Process_Notice': 'Are you sure you want to pass this application ?',
    'Change_Process_Notice': 'Are you sure you want to change the price of this application ?',

    'Operation_succeeded': 'Operation succeeded.',
    'Operation_failed': 'Operation failed',
    'Update_Progress_Succeed': 'The Appliance is updated successfully, will turn back to the application list.',
    'Update_Progress_Fail': 'Fail to update the appliance, please contact the DDV depart.',

    'Applied': 'Applied',
    'Applicant': 'Applicant',
    'Sales_Director': 'Sales Director',
    'No_salesdirector_Warning': 'Approval cannot be created because of no sales director now',

    'Proposal_Cost_Exp': 'Proposal cost includes: Media cost + Production cost',
    'Media_Discount_Exp': 'Media cost x Reduced rate + Production cost',
    'Proposal_Discount_Exp': '(Media cost + Production cost) x Reduced rate',
    'Total_Cost_Exp': 'Including: Media cost + Production cost',
    'number_proposal':'QTTY',
    'avg_viewed_impression':'AVG.Viewed Impressions',
    'avg_price':'AVG.Proposal Value',
    'avg_bus_line':'Avg.Bus Line QTTY',
    'avg_bus_body':'AVG.Bus Body QTTY',

    'No_data':'No data',
    
    'Auth_warning_message': 'Session timeout or other authentication errors, please log in again',
    'Error_title': 'Sorry, server error encounted...',
    'Error_message_1': 'You could: ',
    'Error_message_2': '1. Back to home page',
    'Error_message_3': '2. Contact us',

    'Start_date': 'Start date',
    'End_date': 'End date',
    'Message': 'Message',
    'User_name': 'User name',
    'File_name': 'File name',
    'All': 'All',

    'Create': 'Create',
    'Inventory_list': 'Inventory list',
    'Bus_line': 'Line',
    'Ranking': 'Rank',
    'Plate': 'Plate',
    'Bus_id': 'ID',
    'Bus_model': 'Bus model',
    'Status_start': 'Status Start',
    'Status_end': 'Status End',
    'Reservation_start': 'Resv. Start',
    'Reservation_end': 'Resv. End',
    'Contract_start': 'Contract Start',
    'Contract_end': 'Contract End',
    'Production_start': 'Prod. Start',
    'Production_end': 'Prod. End',

    'single_deck_2_panels': 'SD 2 Panels',
    'single_deck_3_panels': 'SD 3 Panels',
    'single_deck_half_bus_wrap': 'SD Half Body',
    'single_deck_full_bus_wrap': 'SD Full Body',
    'single_deck_full_bus_wrap_plus': 'SD Full Body Plus',
    'double_deck_full_bus_wrap': 'DD Full Body',

    'vehicle_status_0': 'Normal',
    'vehicle_status_1': 'Maintain',
    'vehicle_status_2': 'Scrapped',
    'vehicle_status_3': 'Controlled',
    'vehicle_status_4': 'Priority',
    'vehicle_status_5': 'Others',

    'add_bus_body': 'Add Bus Body',
    'edit_bus_body': 'Edit Bus Body',
    'Please_select_rank': 'Please select rank',
    'Please_select_status': 'Please select status',
    'Status_date_range': 'Status Date Range',
    'Reservation_date_range': 'Resv. Date Range',
    'Contract_date_range': 'Contr. Date Range',
    'Production_date_range': 'Prod. Date Range',

    'Required_field': 'Required field',
    
    'bus_body_already_exists': 'Error: Bus plate already exists.',
    'bus_body_create_failed': 'Error: Failed to create bus body.',
    'bus_body_create_successfully': 'Bus body create successfully.',
    'bus_body_not_exists': 'Error: Bus plate not exists.',
    'bus_body_edit_failed': 'Error: Failed to edit bus body.',
    'bus_body_edit_successfully': 'Bus body edit successfully.',
    'bus_body_delete_failed': 'Error: Failed to delete bus body.',
    'bus_body_delete_successfully': 'Bus body delete successfully.',
    'Bus_body_delete_notice': 'This operation will permanently delete the bus body：plate, continue ?',

    'Search_bus_line': 'Search bus line',
    'Search_plate': 'Search plate',
    'Search_bus_id': 'Search bus id',

    'number_proposal':'QTTY',
    'avg_viewed_impression':'AVG.Viewed Impressions',
    'avg_price':'AVG.Proposal Value',
    'avg_bus_line':'Avg.Bus Line QTTY',
    'avg_bus_body':'AVG.Bus Body QTTY',
    
    'Quiz_message': 'Click to test your level of DOOH Glossary !',

    'BU_Statistic':'BU',
    'City_Statistic':'City',
    'Bussiness_Statistic':'Bussiness Statistic',
    'Activities_Statistic':'Activity Statistic',
    'Search_by':'Search by',
    'Date_range':'Date Range',
    'Metrics':'KPI',
    'Dimension':'Dimension',
    'Dimension_filter':'Dimension Filter',
    'Time_dimension':'Time Dimension',
    'Submit':'Submit',
    'Export':'Export',
    'Activities':'Activity',
    'Sessions':'Session',
    'UV':'Unique Visitor',
    'New_proposal':'New Proposal',
    'Active_proposal':'Active Proposal',
    'New Proposal':'New Proposal',
    'Active Proposal':'Active Proposal',
    'chart_title_by_time_yoy': 'Total {{metrics}} and YOY Trend',
    'chart_title_by_bu':'{{metrics}} Distribution for Each {{bu_dimension}}',
    'chart_title_by_bu_trend':'{{metrics}} Trend for Each {{bu_dimension}}',
    'chart_title_bu_bu_stacked':'{{metrics}} Stacked Total and Trend for Each {{bu_dimension}}',
    'chart_title_by_user':'{{metrics}} Ranking by User',
    'Year':'Year',
    'Year-Month':'Year-Month',
    'Year-Week':'Year-Week',
    'Hour':'Hour',
    'Definition_session':'The count of logins, calculated according to session,1 session = 1 visit',
    'Definition_activity':'The count of activities including login, create and update proposal',
    'Definition_UV':'The count of users, 1 user login to the platform in 1 day counts 1 UV',
    'Definition_New_proposal':'The count of all proposals created in selected date range',
    'Definition_Active_proposal':'The count of proposals created in selected date range and now in status of “sent”, “discussion” and “win” ',
    'YOY':'Year Over Year',
    'remark_search':'*The results only show KPI from your BU(bu)',
    'no_data_statistic_v2':'There is no data about {{metrics}} in the time range you selected',
    'last_year_kpi':'This KPI in last year\'s selected date range is:' ,

    'add_user':'Add JCD user',
    'add_external_user':'Add external user',
    'company':'Company',
    'initial_password':'Initial Password',
    'external':'External',
    'internal':'Internal',
    'disable_user':'Disable',
    'enable_user':'Enable',
    'new_password':'New password',
    'confirm_new_password':'Confirm new password',
    'activate':'Activate',
    'account_has_been_activated':'This external account has already been activated, please login... ',
    'change_password':'Change password',
    'pwd_cannot_be_null':'Password cannot be empty',
    'pwd_inconsistent':'The two entered passwords are inconsistent',
    'pwd_length_longer_than_12':'Password must be at least 12 characters',
    'pwd_contains_character':'Password should have one uppercase letter,one lowercase letter, and one number',
    'pwd_not_repeated':"Users can't reuse any of their last 5 passwords",
    'pwd_expired':'Your password will be expired, please change you password',

  },
  ...enLocale
}

export default en
